import { saveFavorites } from 'App/sources/FavoritePages';

import { useMutation, useQueryClient } from '@gogame/query';

import { favorites, save } from '../queryKeyFactory';

export const useSaveFavorites = () => {
  const queryClient = useQueryClient();

  const queryKey = favorites();

  const saveMutation = useMutation(save(), saveFavorites, {
    refresh: false,
    onMutate: async ({ ids }) => {
      await queryClient.cancelQueries(queryKey);

      const previousValue = queryClient.getQueryData(queryKey);

      queryClient.setQueryData(queryKey, ids);

      return previousValue;
    },
    onError: (_, __, previousValue) =>
      queryClient.setQueryData(queryKey, previousValue),
  });
  return [saveMutation.mutateAsync, saveMutation];
};
